import { AvatarConfig } from "../avatar/common/player/type";
import { ResourceType } from "../base/loader/type";
import { SmartScenarioBuilders } from "../avatar/common/player/util";
import { defaultConfig } from "./default.config";
import type { CameraConfig } from '../base/camera/type';
import type { LightingConfig } from '../base/light/type';
import type { RendererConfig } from '../base/renderer/type';
import type { LoaderConfig } from '../base/loader/type';
import type { ScenarioConfigs } from '../avatar/common/animation/type';

// Glitch 리소스 설정
export const glyxResources: ResourceType[] = [
  { name: "glyx", type: "model_only", format: "glb", path: "/glb/avatars/gl_avatar_glyx_00001.glb" },
  { name: "greeting_entrance01", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@greeting_entrance01.glb" },
  { name: "input_listening01_a", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_listening01_a.glb" },
  { name: "input_listening01_b", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_listening01_b.glb" },
  { name: "input_listening02_a", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_listening02_a.glb" },
  { name: "input_listening02_b", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_listening02_b.glb" },
  { name: "input_listening03_a", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_listening03_a.glb" },
  { name: "input_listening03_b", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_listening03_b.glb" },
  { name: "input_listening04_a", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_listening04_a.glb" },
  { name: "input_listening04_b", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_listening04_b.glb" },
  { name: "input_processing01_a", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_processing01_a.glb" },
  { name: "input_processing01_b", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_processing01_b.glb" },
  { name: "input_processing02_a", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_processing02_a.glb" },
  { name: "input_processing02_b", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_processing02_b.glb" },
  { name: "input_processing03_a", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_processing03_a.glb" },
  { name: "input_processing03_b", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_processing03_b.glb" },
  { name: "input_waiting01_a", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_waiting01_a.glb" },
  { name: "input_waiting01_b", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_waiting01_b.glb" },
  { name: "input_waiting02_a", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_waiting02_a.glb" },
  { name: "input_waiting02_b", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_waiting02_b.glb" },
  { name: "input_waiting03_a", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_waiting03_a.glb" },
  { name: "input_waiting03_b", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_waiting03_b.glb" },
  { name: "input_waiting04_a", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_waiting04_a.glb" },
  { name: "input_waiting04_b", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@input_waiting04_b.glb" },
  { name: "payment_toss01", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@payment_toss01.glb" },
  { name: "response_error01_a", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@response_error01_a.glb" },
  { name: "response_error01_b", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@response_error01_b.glb" },
  { name: "response_error01_c", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@response_error01_c.glb" },
  { name: "response_speaking01", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@response_speaking01.glb" },
  { name: "response_speaking02", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@response_speaking02.glb" },
  { name: "response_speaking03", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@response_speaking03.glb" },
  { name: "response_speaking04", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@response_speaking04.glb" },
  { name: "response_speaking05", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@response_speaking05.glb" },
  { name: "response_speaking06", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@response_speaking06.glb" },
  { name: "response_productinfo01", type: "animation_only", format: "glb", path: "/glb/animations/glitch/gl_glitch@response_productinfo01.glb" },
];

/**
 * Glitch 시나리오 설정 - 3가지 방법 지원
 * 1. 스마트 빌더 (베이스 이름만으로 자동 구성) ⭐️ 권장
 * 2. JSON 호환 방식
 * 3. 기존 상세 빌더 방식
 */

// 방법 1: 스마트 빌더 사용 (베이스 이름만 입력, 자동 탐지) ⭐️
const GLYX_SCENARIOS: ScenarioConfigs<string> = {
  // 베이스 이름만 입력하면 자동으로 탐지!
  entrance: SmartScenarioBuilders.auto("greeting_entrance", glyxResources, {
    preferredMode: 'once',
    description: "아바타 입장 애니메이션",
    nextScenario: "toss"
  }),

  // "input_listening"만 입력하면 자동으로 input_listening01_a, input_listening01_b 등을 찾아서 적절한 패턴 구성
  listening: SmartScenarioBuilders.auto("input_listening", glyxResources, {
    preferredMode: 'last_loop',
    description: "사용자 입력을 듣는 상태"
  }),

  processing: SmartScenarioBuilders.auto("input_processing", glyxResources, {
    preferredMode: 'last_loop',
    description: "사용자 입력을 처리하는 상태"
  }),

  waiting: SmartScenarioBuilders.auto("input_waiting", glyxResources, {
    preferredMode: 'last_loop',
    description: "대기 상태"
  }),

  // "response_speaking"만 입력하면 speaking01~06을 자동으로 찾아서 랜덤 모드로 구성
  speaking: SmartScenarioBuilders.auto("response_speaking", glyxResources, {
    preferredMode: 'random',
    description: "말하기 상태"
  }),

  toss: SmartScenarioBuilders.auto("payment_toss", glyxResources, {
    preferredMode: 'once',
    description: "결제 완료 애니메이션"
  }),

  // error 시나리오: 수동 정의 (자동 탐지에서 존재하지 않는 애니메이션을 찾으려는 문제 방지)
  error: {
    animations: ["response_error01_a", "response_error01_b"],
    playMode: 'last_loop',
    selectionMode: 'none',
    blendDuration: 0.2,
    description: "에러 상태 애니메이션",
    animationPattern: 'paired_sequence',
    options: {
      isLastAnimationLoop: true
    }
  },

  error_end: {
    animations: ["response_error01_c"],
    playMode: 'once',
    selectionMode: 'none',
    blendDuration: 0.2,
    description: "에러 상태 종료 애니메이션",
    animationPattern: 'single'
  },
};


// 카메라 설정
const glyxCameraConfig: CameraConfig = {
  ...defaultConfig.camera
};

// 조명 설정  
const glyxLightConfig: LightingConfig = {
  ...defaultConfig.lighting,
  lights: []
};

// 렌더러 설정
const glyxRendererConfig: RendererConfig = {
  ...defaultConfig.renderer,
  renderer: {
    ...defaultConfig.renderer.renderer,
  }
};

const glyxLoaderConfig: LoaderConfig = {
  ...defaultConfig.loader,
};

export const glyxAvatarConfig: AvatarConfig = {
  type: 'glyx' as const,
  modelKey: 'glyx',
  resources: glyxResources,
  scenarioConfigs: GLYX_SCENARIOS,
  scale: { x: 1, y: 1, z: 1 },
  bloom: {
    emissiveIntensity: 20,
    meshNames: ['Head_Eyes', 'Head_Teeth'],
    specialSettings: {
      applySpecularEffect: true,
      transmission: 1,
      roughnessMultiplier: 0.8,
    }
  },
  lipsync: {
    indices: [24, 31, 37, 45, 46],
    processingType: 'range_mapping',
    config: {
      sourceIndex: 24,
      targetMappings: [
        { maxValue: 0, targetIndex: 46 },
        { maxValue: 0, targetIndex: 45 },
        { maxValue: 0, targetIndex: 37 },
        { maxValue: 0, targetIndex: 31 },
        { maxValue: 0, targetIndex: 24 },
      ],
      resetIndices: [46, 45, 37, 31, 24],
    }
  }
};

// Glitch 통합 설정 인터페이스
export interface GlyxConfig {
  loader: LoaderConfig;
  camera: CameraConfig;
  lighting: LightingConfig;
  renderer: RendererConfig;
  avatar: AvatarConfig;
}

/**
 * Glitch 설정 통합 객체
 */
export const glyxConfig: GlyxConfig = {
  loader: glyxLoaderConfig,
  camera: glyxCameraConfig,
  lighting: glyxLightConfig,
  renderer: glyxRendererConfig,
  avatar: glyxAvatarConfig
};